import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=556b2f9d&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=556b2f9d&lang=scss&scoped=true"
import style1 from "./GlobalSearch.vue?vue&type=style&index=1&id=556b2f9d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b2f9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556b2f9d')) {
      api.createRecord('556b2f9d', component.options)
    } else {
      api.reload('556b2f9d', component.options)
    }
    module.hot.accept("./GlobalSearch.vue?vue&type=template&id=556b2f9d&scoped=true", function () {
      api.rerender('556b2f9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GobalSearch/GlobalSearch.vue"
export default component.exports